export default __webpack_public_path__ + "4ae020865eec76e6c7cc249e15268e77.woff";